import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import {
  DataProtectionNoticeListInitialState,
  DataProtectionNoticeListLoad,
} from './data-protection-notice-list.actions';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DataProtectionNoticeListService } from './data-protection-notice-list.service';
import { DataProtectionNoticeList } from '../models/data-protection-notice.model';

import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface DpnListStateModel {
  dpnList: DataProtectionNoticeList[];
  defaultDpns: DataProtectionNoticeList[];
  countrySpecificDpns: DataProtectionNoticeList[];
  loaded: boolean;
}

const initialState: DpnListStateModel = {
  dpnList: null,
  defaultDpns: null,
  countrySpecificDpns: null,
  loaded: false,
};

@State<DpnListStateModel>({
  name: 'dataProtectionNoticeList',
  defaults: initialState,
})
@Injectable()
export class DataProtectionNoticeListState {
  constructor(
    private dpnListService: DataProtectionNoticeListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: DpnListStateModel): DpnListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: DpnListStateModel): DataProtectionNoticeList[] {
    return state.dpnList;
  }

  @Selector()
  static getLoaded(state: DpnListStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getCountrySpecificDpns(state: DpnListStateModel): DataProtectionNoticeList[] {
    return state.countrySpecificDpns;
  }
  @Selector()
  static getDefaultDpns(state: DpnListStateModel): DataProtectionNoticeList[] {
    return state.defaultDpns;
  }

  @Action(DataProtectionNoticeListLoad)
  getDataProtectionNoticeList(ctx: StateContext<DpnListStateModel>): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.dpnListService.getDpnList().pipe(
      map((dpnList: DataProtectionNoticeList[]) => {
        ctx.patchState({
          dpnList,
          countrySpecificDpns: dpnList.filter((dpn: DataProtectionNoticeList) => !dpn.defaultDpn),
          defaultDpns: dpnList.filter((dpn: DataProtectionNoticeList) => dpn.defaultDpn),
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(DataProtectionNoticeListInitialState)
  setInitialState(ctx: StateContext<DpnListStateModel>): void {
    ctx.setState(initialState);
  }
}
